import { CodeBase } from "./_codeBase";

/** 機器作業操作区分*/
export class EquipmentWorkOperationDiv extends CodeBase<EquipmentWorkOperationDiv>
{
    /** 機器作業操作区分: "01", "操作不可"*/
    public static readonly INOPERABLE: EquipmentWorkOperationDiv = new EquipmentWorkOperationDiv("01", "操作不可", "");

    /** 機器作業操作区分: "02", "操作可（追加・削除）"*/
    public static readonly OPERABLE: EquipmentWorkOperationDiv = new EquipmentWorkOperationDiv("02", "操作可（追加・削除）", "○");


    /**
     * 
     * @param value
     * @param text
     */
    protected constructor(value: any, text: string, abbr?: any) {
        super(value, text, abbr);
    }

    /**
     * 
     */
    public static List(): EquipmentWorkOperationDiv[] {
        return [
            EquipmentWorkOperationDiv.INOPERABLE,
            EquipmentWorkOperationDiv.OPERABLE,


        ];
    }
}
